import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { Cell, CellType } from '../../../../common/tables/table'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-dynamic-property-cell',
  templateUrl: './dynamic-property-cell.component.html',
  styleUrls: ['./dynamic-property-cell.component.scss'],
  imports: [AsyncPipe],
})
export class DynamicPropertyCellComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private _cell$ = new BehaviorSubject<Cell>(null)

  public readonly CellType = CellType

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  @Input()
  public set cell(cell: Cell) {
    this._cell$.next(cell)
  }

  public get cell(): Cell {
    return this._cell$.getValue()
  }

  public get cell$(): Observable<Cell> {
    return this._cell$.asObservable()
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onPreviewLoadError($event: ErrorEvent) {
    this.log.warn('Could not load image!')
  }

  public replaceLineSeparator(text: string): string {
    return text?.replace(/\n/g, '<br>')
  }
}
